import styled, { css } from 'styled-components/macro';
import { colorCoreBlack900Base, colorBrandYamahaRed, colorBlackTransparent200, colorCoreWhite1000, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
import { TooltipPlacement, TooltipState } from './types';
export const TooltipStyled = styled.div `
  position: absolute;
  z-index: ${Z_INDEX.popupLevel2};
  width: max-content;
  max-width: 300px;
  box-sizing: border-box;
  padding: 6px 12px;
  border-radius: ${CORNER_RADIUS.s};
  background-color: ${colorCoreBlack900Base};
  background-color: ${({ state }) => state === TooltipState.DEFAULT ? colorCoreBlack900Base : colorBrandYamahaRed};
  color: ${colorCoreWhite1000};
  box-shadow: 0px 3px 20px ${colorBlackTransparent200};

  ${getTextStyles('Ubuntu', 400, 14, 20)}

  &::after {
    content: '';
    position: absolute;
    height: 8px;
    width: 8px;
    pointer-events: none;
    background-color: inherit;
  }

  ${({ placement }) => placement === TooltipPlacement.ABOVE_LEFT &&
    css `
      &::after {
        top: 100%;
        left: 16px;
        transform: translateY(-50%) rotate(45deg);
      }
    `}

  ${({ placement }) => placement === TooltipPlacement.ABOVE_CENTER &&
    css `
      &::after {
        top: 100%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
      }
    `}

  ${({ placement }) => placement === TooltipPlacement.ABOVE_RIGHT &&
    css `
      &::after {
        top: 100%;
        right: 16px;
        transform: translateY(-50%) rotate(45deg);
      }
    `}

  ${({ placement }) => placement === TooltipPlacement.BELOW_LEFT &&
    css `
      &::after {
        top: 0;
        left: 16px;
        transform: translateY(-50%) rotate(45deg);
      }
    `}

  ${({ placement }) => placement === TooltipPlacement.BELOW_CENTER &&
    css `
      &::after {
        top: 0;
        left: 50%;
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
      }
    `}

    ${({ placement }) => placement === TooltipPlacement.BELOW_RIGHT &&
    css `
      &::after {
        top: 0;
        right: 16px;
        transform: translateY(-50%) rotate(45deg);
      }
    `}

    ${({ placement }) => placement === TooltipPlacement.LEFT &&
    css `
      &::after {
        top: 50%;
        right: 0;
        transform: translateY(-50%) translateX(50%) rotate(45deg);
      }
    `}

    ${({ placement }) => placement === TooltipPlacement.RIGHT &&
    css `
      &::after {
        top: 50%;
        left: 0;
        transform: translateY(-50%) translateX(-50%) rotate(45deg);
      }
    `}
`;
